import { DocumentData, DocumentReference } from "@angular/fire/firestore";
import { ProductType } from "../../product/enums";

export class ProductSummary {
  public readonly instructions: string;
  public readonly name: string;
  public readonly reference: DocumentReference;
  public readonly type: ProductType;
  public readonly warning: string;

  constructor(data: DocumentData) {
    this.name = data.name;
    this.instructions = data.instructions;
    this.reference = data.reference as DocumentReference;
    this.warning = data.warning;
    this.type = data.type as ProductType;
  }
}
